import Config from 'config/settings';
import { globals } from 'config/globals';
import { Module } from 'core/Module';
import DelayHelper from 'utils/timers';

export class LoaderGraphic extends Module {
	public onLoaderGraphicComplete: CallableFunction;

	private _$loaderbar: HTMLElement;
	private _$loaderbarvalue: HTMLElement;
	private _$logoImage: HTMLElement;
	private _$circleloader: HTMLElement;

	private _tweenLoader: any; //gsap tween for the loader bar

	private _loaderRatioShare = 0.8;
	private _initRatioShare = 0.2;
	private _initProgress = 0;
	private _loaderProgress = 0;
	private _loaderPhaseIsComplete = false;
	private _delay = 600;
	private _isCircleType: boolean = true;

	public create(): void {
		globals.inCircleLoader = this._isCircleType;

		this.$container.querySelector('.home__logo__image.-masked');
		this._$circleloader = document.querySelector('.circular-progress.-home');
		this._$loaderbar = document.querySelector('.preload-bar');
		this._$loaderbarvalue = document.querySelector('.preload-bar-value');
		document.querySelector('.debug-logo-loader');
		this._$logoImage = document.querySelector('.debug-logo-loader-image');
		gsap.TweenMax.set(this._$loaderbarvalue, { scaleX: 0.0002, opacity: 0 });
	}

	public setLoadPercentages(core, init, delay) {
		this._loaderRatioShare = core;
		this._initRatioShare = init;
		this._delay = delay;
	}

	public homeParticlesCreated() {
		this._initProgress = 1;

		//Add some breathing room for freezing etc
		DelayHelper.setTimeout(() => {
			this.setMixedRatio();
		}, this._delay);
	}

	public homePixelDataReady() {
		return;
		this._initProgress += 0.5;
		DelayHelper.setTimeout(() => {
			this.setMixedRatio();
		}, 400);
	}

	public progress(ratio: number): void {
		this._loaderProgress = ratio;
		this.setMixedRatio();
	}

	/**
	 * Things like creating PIXI scene freeze up the UI, so factor them into the preload
	 * So preload is the assets + allowenace for things like adding PIXI elements
	 */
	private setMixedRatio() {
		let ratio = this._loaderProgress * this._loaderRatioShare + this._initRatioShare * this._initProgress;

		console.log('this._loaderProgress', this._loaderProgress);
		console.log('(this._initRatioShare ', this._initRatioShare);
		console.log(
			'ratioratioratioratioratio',
			ratio,
			this._loaderProgress * this._loaderRatioShare,
			this._initRatioShare * this._initProgress
		);

		gsap.TweenMax.set(this._$loaderbarvalue, { scaleX: ratio, opacity: 1 });

		if (this._tweenLoader) this._tweenLoader.kill();

		let dashoffset = 785.398163397 - 785.398163397 * ratio;
		this._$circleloader.querySelector('svg').style.setProperty('stroke-dashoffset', dashoffset + '');


		if (ratio >= 1) {

			setTimeout(() => {
				this.loaderPhaseComplete();
			}, 1000);
		}
	}

	private loaderPhaseComplete() {

		if (this._loaderPhaseIsComplete) {
			return;
		}

		this._loaderPhaseIsComplete = true;

		this.animateOut();


		//As faking some loading times to provide better feedback then this is the real end of the loading and when the other elements can show
		if (this.onLoaderGraphicComplete) {
			this.onLoaderGraphicComplete();
		}
	}

	public animateOut(): void {

		if (this._isCircleType) {
			this.DOM.addClass(this._$circleloader, '-loadcomplete');

			setTimeout(() => {
				this.DOM.addClass(this._$circleloader, '-done');
			}, 700);

			gsap.TweenMax.to(this._$logoImage, 0.6, { scaleX: 0.4, scaleY: 0.4, opacity: 0, ease: Config.standardEase });
			return;
		}

		gsap.TweenMax.to(this._$loaderbar, 0.6, { scaleX: 0, ease: Config.standardEase });

		gsap.TweenMax.to(this._$logoImage, 0.6, { scaleX: 0.4, scaleY: 0.4, y: 80, ease: Config.standardEase });
	}

	public animateIn(): void {
	}
}
